import { withProps, compose, withHandlers, lifecycle } from 'recompose';
import { connect } from 'react-redux';
import { getFilteredRoutes, getQuerySearch, getPathname } from 'reselects';
import { replaceWithQuery as replace } from 'utils/routing';
import { searchVehicles as searchVehiclesAction } from 'redux/modules/vehicle-section/effects';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import VehicleFilters from './component';

const actionCreators = {
  searchVehicles: searchVehiclesAction,
};

const enhance = compose(
  injectIntl,
  withRouter,
  connect((state, ownProps) => {
    return {
      routes: getFilteredRoutes(state, (route) => route.defined),
      query: getQuerySearch(ownProps),
      pathname: getPathname(ownProps),
    };
  }, actionCreators),
  withProps(({ query }) => ({
    disableFilter: !!query.driver,
  })),
  withHandlers({
    handleChangeFilter:
      ({ pathname, searchVehicles, query }) =>
      (filter) => {
        return (value) => {
          let newQuery = {
            ...query,
          };
          if (Array.isArray(filter)) {
            filter.forEach((individualFilter, i) => {
              newQuery[individualFilter] = value[i] || undefined;
            });
          } else {
            newQuery = {
              ...query,
              [filter]: value === 'ANY' || !value ? undefined : value,
            };
          }
          replace({ pathname, query: newQuery });
          searchVehicles(newQuery);
        };
      },
    handleChangeFilterCheckbox:
      ({ query, searchVehicles, pathname }) =>
      (filter) => {
        return (_, { value }) => {
          const newQuery = {
            ...query,
            [filter]: value || undefined,
          };
          replace({ pathname, query: newQuery });
          searchVehicles(newQuery);
        };
      },
    handleChangeFilterMulti:
      ({ query, searchVehicles, pathname }) =>
      (filter) => {
        return (values) => {
          const flatValuesString = values?.map((item) => item.value).join(',');
          const newQuery = {
            ...query,
            [filter]: flatValuesString || undefined,
          };
          replace({ pathname, query: newQuery });
          searchVehicles(newQuery);
        };
      },
  }),

  lifecycle({
    componentDidMount() {
      const { searchVehicles, query } = this.props;
      query ? searchVehicles(query) : searchVehicles();
    },
  })
);

export default enhance(VehicleFilters);
